import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_1Y_161_99_1Y_89',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_1y_161_99_1y_89_usd',
		},
		primer: 'prd_9Jm9J7WLu2Kq',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 12,
		intro_period_type: 'months',
		next_period_value: 1,
		next_period_type: 'year',
	},
	trial: {
		days: 365,
		priceMap: {
			USD: 89,
		},
		originalPriceMap: {
			USD: 161.99,
		},
	},
	subscription: {
		interval: 'year',
		intervalCount: 1,
		priceMap: {
			USD: 161.99,
		},
	},
	options: () => ({
		// 'pages.program.organic.cheap_and_short.plans.365_days.into_period_text'
		explicitTermsPeriodText: 'first year',
		// 'pages.program.organic.cheap_and_short.plans.365_days.sub_period_text'
		explicitTermsIntervalText: 'yearly',
		// 'pages.program.cheap_and_short.plans.365_days.into_period_text'
		billingSubtitlePeriodText: 'year',
		// 'common.duration.year.dashed.lowercase'
		footerPeriodText: '1-Year',
		// 'pages.program.cheap_and_short.plans.365_days.sub_period_text'
		footerIntervalText: 'yearly',
	}),
}
